module.exports = __webpack_public_path__ + "img/body-position-chart-slide2.a353b644.gif";